import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Scheduling } from "@/types";

export interface SynchronizeScheduleRequest {
  message: string;
  data: Scheduling;
}

async function createSynchronizeSchedule(id: string) {
  const response = await httpRequest.post<SynchronizeScheduleRequest>(
    `/schedulings/sync/${id}`
  );
  return response.data;
}

export function useCreateSynchronizeScheduleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createSynchronizeSchedule,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings"] });
    },
  });
}
